import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./BillingCards.module.scss";
import CustomButton from "../../../components/ui/CustomButton/CustomButton";
import PaymentMethodEmpty from "../../../components/shared/PaymentMethodEmpty/PaymentMethodEmpty";
import BillingCard from "./BillingCard/BillingCard";
import { useGetStripePaymentMethodsQuery } from "../../../api/queries";
import AddNewPaymentMethodPopup from "../../../components/shared/AddNewPaymentMethodPopup/AddNewPaymentMethodPopup";

const BillingCards = () => {
  const { t } = useTranslation();

  const [showAddNewPopup, setShowAddNewPopup] = useState<boolean>(false);
  const { data, isLoading, refetch } = useGetStripePaymentMethodsQuery();

  if (!isLoading && !data?.paymentMethods?.length) {
    return (
      <div className={styles.container}>
        <h2 className={styles.title}>{t("BillingInformation")}</h2>
        <PaymentMethodEmpty />
      </div>
    );
  }

  if (!data?.paymentMethods?.length) return null;

  return (
    <>
      <div className={styles.container}>
        <h2 className={styles.title}>{t("BillingInformation")}</h2>
        <div className={styles.wrapper}>
          {data.paymentMethods.map((el: any) => {
            return <BillingCard key={el.id} paymentMethod={el} getAllPaymentMethod={refetch} />;
          })}
        </div>
        <div className={styles.btnWrapper}>
          <CustomButton
            text={t("AddNewCard")}
            type={"button"}
            typeStyle={"fill"}
            functionOnClick={() => setShowAddNewPopup(true)}
          />
        </div>
      </div>
      {showAddNewPopup && (
        <AddNewPaymentMethodPopup onClose={() => setShowAddNewPopup(false)} refetch={refetch} />
      )}
    </>
  );
};

export default BillingCards;
